<template>
  <div class="invoice-body">
    <div class="body-box">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" v-if="funcView.invoiceBody_add" @click="onAddBody()">{{$t('Common.com_add')}}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right;">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('fms_body-table.qymcnsrsbh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table v-if="funcView.invoiceBody_open_list" height="100%" type="radio" v-model="selectRow"  :data="tableList" tableCode="invoiceBody" :index="true" @filter="filterChange" @sort="sortChange" @column="setColumn">
          <template slot="action" slot-scope="scope">
            <span></span>
            <el-button @click="onEditBody(scope.row)" v-if="funcView.invoiceBody_edit" type="text" size="mini">{{$t('Common.com_edit')}}</el-button>
            <el-button @click="onDeleteBody(scope.row.partnerInvoiceId)" v-if="funcView.invoiceBody_delete" type="text" size="mini">{{$t('Common.com_delete')}}</el-button>
            <el-button @click="onDefault(scope.row.partnerInvoiceId)"  type="text" size="mini" v-if="funcView.invoiceBody_default && scope.row.isDefault === 0">{{funcView.invoiceBody_default}}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page" v-if="funcView.invoiceBody_list">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div class="item-box">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary"  v-if="funcView.invoiceBody_item_add" :disabled="!selectRow.partnerInvoiceId" icon="el-icon-plus" @click="onAddBodyItem()">{{funcView.invoiceBody_item_add}}</el-button>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formItemSearch.search" :placeholder="$t('fms_body-table.spbhspmc')" @fetch="onItemPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table v-if="funcView.invoiceBody_bus_list" height="100%" :data="itemList" :column="tableColumn" tableCode="invoiceBodyItem" :index="true" @filter="filterChange" @sort="sortChange">
          <template slot="action" slot-scope="scope">
            <span></span>
            <el-button @click="onEditBodyItem(scope.row)" v-if="funcView.invoiceBody_item_edit" type="text" size="mini">{{$t('Common.com_edit')}}</el-button>
            <el-button @click="onDeleteBodyItem(scope.row.partnerInvoiceItemId)" v-if="funcView.invoiceBody_item_delete" type="text" size="mini">{{$t('Common.com_delete')}}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page" v-if="funcView.invoiceBody_bus_list">
        <custom-page :total="itemTotalRows" :page="formItemSearch.pageNum" :size="formItemSearch.pageSize" @change="onItemPageChange"></custom-page>
      </div>
    </div>
    <!-- 新增编辑推送规则  -->
    <body-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></body-item-dialog>
    <!-- 新增商品信息-->
    <commodity-add-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getInvoiceItemPage"></commodity-add-dialog>
    <!-- 编辑商品信息 -->
    <commodity-edit-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getInvoiceItemPage"></commodity-edit-dialog>
  </div>
</template>

<script>
/** 我发起的 */

import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import bodyItemDialog from '@/pages/fms/components/body_item_dialog.vue';
import commodityAddDialog from './commodity_add_dialog.vue';
import commodityEditDialog from './commodity_edit_dialog.vue';

export default {
  mixins: [resetFormSearchMixins],
  components: {
    bodyItemDialog,
    commodityAddDialog,
    commodityEditDialog
  },
  data() {
    return {
      // tableCode: 'invoiceBody',
      formSearch: {
        invoiceOrgType: null, // 工发票方类型 0-开票方，1-受票方 【默认开票方】
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      selectRow: {},
      dialogVisible: false,
      dialogModel: {},

      // -------商品信息
      formItemSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerInvoiceId: null,
      },
      itemList: [],
      itemTotalRows: 0,

      dialogVisible1: false,
      dialogModel1: {},

      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  watch: {
    selectRow: function () {
      this.onWatchSelect();
    }
  },
  methods: {
    // --------------发票主体
    onAddBody: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('fms_body-table.xzfpzt');
      this.dialogVisible = true;
    },
    onEditBody: function (row) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('fms_body-table.bjfpzt');
      this.dialogModel.data = row;
      this.dialogVisible = true;
    },
    onDeleteBody: function (id) {
      const tips = this.$t('fms_body-table.qdyscdqxzdfbztm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceDelete}/${id}`).then(() => {
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    onDefault: function (id) {
      const tips = this.$t('fms_body-table.qdyjdqxzdfbztswmrm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceUpdateIsDefault}/${id}`).then(() => {
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.crmPartnerInvoicePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
        // 清空选中
        this.selectRow = {};
      });
    },

    // -----------------商品信息
    onWatchSelect() {
      if (this.selectRow.partnerInvoiceId) {
        this.formItemSearch.partnerInvoiceId = this.selectRow.partnerInvoiceId;
        this.getInvoiceItemPage();
      } else {
        this.itemList = [];
        this.itemTotalRows = null;
      }
    },
    getInvoiceItemPage() {
      this.$getJSON(apis.crmPartnerInvoiceItemPage, this.formItemSearch).then((res) => {
        this.itemList = res.data.list;
        this.itemTotalRows = res.data.total;
      });
    },
    onAddBodyItem: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('fms_body-table.xzspxx'); // 添加商品信息列表
      this.dialogModel1.data = this.selectRow;
      this.dialogVisible1 = true;
    },
    onEditBodyItem: function (row) {
      this.dialogModel2.type = 'edit';
      this.dialogModel2.title = this.$t('fms_body-table.bjspxx');// form表单
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
    onDeleteBodyItem: function (id) {
      const tips = this.$t('fms_body-table.qdyscdqxzdspm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.crmPartnerInvoiceItemDelete}/${id}`).then(() => {
            this.getInvoiceItemPage();
          });
        })
        .catch(() => {});
    },
    onItemPageChange: function ({ page, size }) {
      this.formItemSearch.pageNum = page;
      this.formItemSearch.pageSize = size || this.formItemSearch.pageSize;
      this.getInvoiceItemPage();
    },
  },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView('/invoice/invoiceBody');

  },
};
</script>

<style lang="scss">
.invoice-body{
  display: flex;
  flex-direction: column;
  height: 100%;
  .body-box,.item-box{
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
</style>
